import React from 'react';
import "./style.scss";

const TT = ({ active, payload, label }) => {
  if (!active || !(payload && payload.length)) return null;
  const sorted = [...payload].sort((a, b) => (b.value ?? 0) - (a.value ?? 0));
  return (
    <div className="compTooltip">
      <div className="compTooltip__label">
        {label}
      </div>
      {sorted.map((p, i) => (
        <div key={i} className="compTooltip__entry">
          <span style={{ color: p.color || "var(--color-g300)" }}>{p.name}</span>:{" "}
          <b>{p.value}</b>
        </div>
      ))}
    </div>
  );
};

export default TT;
